<!--基本树，统一的样式，由其他树覆盖实现-->
<template>
	<div :style="baseTreeStyle" class="baseTreeBody">
		<customerTree :dataList="dataList" :openAbleMethod="openAbleMethod" :getNextMethod="getNextMethod" :style="getTreeBody">
			<template slot-scope="slotProps">
				<div :class="getNameClassNameList(slotProps.item)" :style="getTreeNodeStyle(slotProps.nowFloor)" @click="clickItem(slotProps.item,slotProps.openAble)">
					<!--  -->
					<div @click.stop="openItem(slotProps.item,slotProps.openAble)" style="display: flex;justify-content: center;align-items: center;">
						<imageView :imgNameList="stateImgNameList" :style="styleOptions.stateImage" :imgIndex="slotProps.openAble?0:1"
						 v-show="stateShowAble(slotProps.item)"></imageView>
					</div>
					<div :style="styleOptions.stateImage" v-show="!stateShowAble(slotProps.item)"></div>
					<imageView v-show="checkShowAble(slotProps.item)" :imgNameList="checkImgNameList" :style="styleOptions.checkImage"
					 :imgIndex="getCheckImgIndex(slotProps.item,nowCheckItem)"></imageView>
					<imageView :imgNameList="typeImgNameList" :style="styleOptions.typeImage" :imgIndex="getTypeImgIndex(slotProps.item)"></imageView>
					<span :style="labelStyle">{{getLabelMethod(slotProps.item)}}</span>
				</div>
			</template>
		</customerTree>
		<div class="load-more" v-if="loadMore" style="height: .2rem;width: 100%;font-size: .1rem;text-align: center;" @click="loadMoreMethod">加载更多</div>
	</div>
</template>

<script>
	import customerTree from '@/components/module/tree/customerTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			customerTree,
			imageView,
		},
		props: {
			labelStyle: {
				type: Object,
				default: () => {
					return {
						'display': 'line-block',
						'min-width': '0',
						'padding-right': '.1rem'
					}
				}
			},
			baseTreeStyle: {
				type: Object,
				default: () => {
					return {
						'margin-top': '.25rem',
						'height': '95%',
						'margin-left': '.2rem',
						//如果不是用于treeBody可能要去掉这行
						'min-width': 'calc(100% - .2rem)'
					}
				}
			},
			isDisAble: {
				type: Function,
				default (item) {
					return false
				}
			},
			loadMore: {
				type: Boolean,
				default: false
			},
			styleOptions: {
				type: Object,
				default: () => {
					return {
						stateImage: {
							'width': '.1rem',
							'height': '.1rem',
							'padding': '.1rem',
						},
						typeImage: {
							'width': '.15rem',
							'height': '.15rem',
							'padding-right': '0.1rem'
						},
						checkImage: {
							'width': '.15rem',
							'height': '.15rem',
							'padding-right': '0.1rem'
						}
					}
				}
			},
			checkShowAble: {
				type: Function,
				default (item) {
					return this.isGroup(item) && this.multiSelect
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			multiSelect: {
				type: Boolean,
				default: false
			},
			maxSelectedNum: {
				type: Number,
				default () {
					return undefined
				}
			},
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			multiCheckedItems: {
				type: Array,
				default () {
					return []
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					return false
				}
			},
			//判断是否为组的方法，默认是有下一级就算，根据具体业务具体覆盖
			isGroup: {
				type: Function,
				default (item) {
					return !isempty(item.next)
				}
			},
			//是否显示打开关闭图标
			stateShowAble: {
				type: Function,
				default (item) {
					return this.isGroup(item)
				}
			},
			//判断两个对象是否为同一个的方法，主要用于判断是否和当前选中项一样
			isSameItem: {
				type: Function,
				default (item, nowItem) {
					if (nowItem == undefined || item == undefined) {
						return item == nowItem
					}
					return JSON.stringify(item) == JSON.stringify(nowItem)
				}
			},
			//每一行的节点div的样式，主要用于不断往右边偏移
			getTreeNodeStyle: {
				type: Function,
				default (nowFloor) {
					return {
						'padding-left': 0.1 * (nowFloor) + 'rem',
						'line-height': '.38rem',
						'height': '.38rem',
					}
				}
			},
			getCheckImgIndex: {
				type: Function,
				default (item, datas) {
					return 0
				}
			},
			//获取当前项的图标，返回typeImgList的下标
			getTypeImgIndex: {
				type: Function,
				default (item) {
					return 0
				}
			},
			checkImgNameList: {
				type: Array,
				default () {
					return ['checkBox/checked.png', 'checkBox/unchecked.png']
				}
			},
			//当前项图标的路径，根路径使用resourcesStore的配置
			typeImgNameList: {
				type: Array,
				default () {
					return ['tree/node_unit.png', 'tree/node_class.png', 'tree/node_dev.png', 'tree/node_unit_select.png',
						'tree/node_class_select.png', 'tree/node_dev_select.png'
					]
				}
			},
			stateImgNameList: {
				type: Array,
				default () {
					return ['tree/tree_open.png', 'tree/tree_close.png']
				}
			},
			getIDMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getLabelMethod: {
				type: Function,
				default (item) {
					return item.name
				}
			},
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
			defaultValue: {
				type: Array,
				default: undefined
			}
		},
		data() {
			return {
				nowCheckItem: undefined,
				closeItems: {
					//哪些项是收起的
				},
				index: 1
			}
		},
		created() {},
		mounted() {
			this.refreshPage(this.dataList)
		},
		destroyed() {},
		computed: {
			getNameClassNameList() {
				//设置当前名字文本框的样式列表，额外添加选中时的样式
				return item => {
					if (this.nowCheckItem == undefined) {
						return ['treeNode']
					}
					if (this.multiSelect) {
						if (this.nowCheckItem.includes(item)) {
							return ["nowCheckItem", 'treeNode']
						} else {
							return ['treeNode']
						}
					} else {
						if (!this.isSameItem(item, this.nowCheckItem)) {
							return ['treeNode']
						}
						return ["nowCheckItem", 'treeNode']
					}
				}
			},
			getTreeBody() {
				return {
					'overflow': 'auto',
					'height': this.loadMore ? 'calc(100% - .2rem)' : '100%'
				}
			}
		},
		watch: {
			dataList(nv, ov) {
				this.refreshPage(nv)
			}
		},
		methods: {
			loadMoreMethod() {
				this.$emit('loadMoreMethod', this)
			},
			refreshPage(list) {
				this.nowCheckItem = undefined
				if(this.multiSelect && !isempty(this.multiCheckedItems)){
					this.multiCheckedItems.forEach(item => {
						this.clickItem(item, false)
					})
				}else{
					if (this.defaultValue) {
						this.defaultValue.forEach(df => {
							var item = findTreeItem(list, (it) => {
								return this.isSameItem(it, df)
							})
							if (isempty(item)) {
								return
							}
							//选中第一个并且默认是打开的
							this.clickItem(item, false)
						})
					} else {
						this.autoSelect(list)
					}
				}
			},
			openAbleMethod(item) {
				//控制项目展开收起
				if (!this.isGroup(item)) {
					//不是组则不会打开
					return false
				}
				if (this.closeItems.hasOwnProperty(this.getIDMethod(item))) {
					//已经关着的不打开
					return false
				}
				return true
			},
			toggleOpen(item, openAble) {
				if (this.isGroup(item)) {//判断是否有组
					if (openAble) {
						this.$set(this.closeItems, this.getIDMethod(item), true)
					} else {
						this.$delete(this.closeItems, this.getIDMethod(item))
					}
				}
			},
			openItem(item, openAble) {
				this.toggleOpen(item, openAble)
			},
			clickItem(item, openAble) {
				//单击事件
				var checkItem = undefined
				if (this.isDisAble(item)) {
					return
				}
				if (this.isGroup(item)) {
					if (this.groupCheckAble) {
						checkItem = item
					}
				} else {
					checkItem = item
				}
				if (checkItem == undefined) {
					return
				}
				if (this.multiSelect) { //多选
					if (this.nowCheckItem == undefined) {
						this.nowCheckItem = []
					}
					var that = this
					//找出所有下级
					function findsonList(item) {
						var list = []
						var sonList = that.getNextMethod(item)
						if (!isempty(sonList)) {
							list = list.concat(sonList)
							sonList.forEach(item => {
								var templist = findsonList(item)
								if (!isempty(templist)) {
									list = list.concat(templist)
								}
							})
						}
						return list
					}
					var checkSon = findsonList(checkItem)
					var index = -1
					for (var i = 0, len = this.nowCheckItem.length; i < len; i++) {
						var temp = this.nowCheckItem[i]
						if (JSON.stringify(checkItem) == JSON.stringify(temp)) {
							index = i
							break
						}
					}
					//找到自己 移除
					if (index != -1) {
						this.nowCheckItem.splice(index, 1)
						this.nowCheckItem = this.nowCheckItem.filter((item, index) => {
							var sonindex = -1
							checkSon.forEach(son => {
								if (JSON.stringify(son) == JSON.stringify(item)) {
									sonindex++
								}
							})
							if (sonindex > -1) {
								return false
							} else {
								return true
							}
						})
					} else {
						if(this.maxSelectedNum != undefined){
							if(this.nowCheckItem.length >= this.maxSelectedNum){
								this.$emit('beyondMaxSelect')
								return
							}
						}
						this.nowCheckItem.push(checkItem)
						checkSon.forEach(son => {
							if (!this.nowCheckItem.includes(son)) {
								this.nowCheckItem.push(son)
							}
						})
					}
					this.$emit("checkItem", this.nowCheckItem)
				} else { //单选
					//选中了同一个
					if (this.isSameItem(item, this.nowCheckItem)) {
						return
					}
					this.nowCheckItem = checkItem
					this.$emit("checkItem", checkItem)
				}
			},
			autoSelect(list) {
				var item = findTreeItem(list, this.autoSelectMethod)
				if (item == undefined) {
					return
				}
				if (this.isGroup(item) && !this.groupCheckAble) {
					return
				}
				//选中第一个并且默认是打开的
				this.clickItem(item, false)
			}
		}
	}
</script>

<style scoped>
	.treeBody {
		/* overflow-y: auto;
		overflow-x: hidden;
		height: 100%; */
	}

	.treeNode {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
		user-select: none;
		height: 0.3rem;
		white-space: nowrap;
		opacity: 0.7;
	}

	.nowCheckItem {
		opacity: 1 !important;
	}
</style>
